import Api from '../api';
import {
  AnnouncementLogs,
  HelpCenterData,
} from '../../Components/HelpCenter/types';

export const helpCenterApi = {
  async getHelpCenterData(userId: string): Promise<HelpCenterData> {
    const response = await Api.get(`/users/${userId}/help-center`);
    return response.data;
  },
  async getAnnouncementLogs(userId: string): Promise<AnnouncementLogs> {
    const response = await Api.get(
      `/users/${userId}/help-center/announcement-logs`,
    );
    return response.data;
  },
};
